module.exports = __webpack_public_path__ + "static/media/app-store.809e747c.png";